import { NgModule } from '@angular/core';
import { AppSpinnerComponent } from './appspinner.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
    declarations: [AppSpinnerComponent],
    exports: [AppSpinnerComponent],
})
export class AppSpinnerModule { }